import _ from "lodash"
import React from "react"
import { FlightText, FragmentFieldName } from "../common/text"
import { IFragmentFieldConfig } from "../pages/Config"

import DropdownField from "./generic/form/DropdownField"
import SeasonDateRange from "./SeasonDateRange"
import { DOOPField } from "./selectorFields"

export interface FragmentValues {
  separationOption: string
  doop: string
  splitOption: string
  startDate: string
  endDate: string
}

interface Props {
  values: FragmentValues
  onChange: (values: FragmentValues) => void
  fragmentConfig?: IFragmentFieldConfig
  showFragment: boolean
  onToggleShowFragment: () => void
  disabled?: boolean
}

//Common text
const { arr, dep, byDays, byDoop } = FlightText

export const FragmentBtn: React.FunctionComponent<Props> = ({
  values,
  onChange,
  fragmentConfig,
  showFragment,
  disabled,
  onToggleShowFragment
}) => {
  const handleChange = (name: FragmentFieldName, val: string) => {
    const updValues = _.cloneDeep(values)
    updValues[name] = val
    if (name === FragmentFieldName.startDate && !values.endDate) {
      updValues.endDate = val
    }
    onChange(updValues)
  }

  const showField = (field: FragmentFieldName) =>
    fragmentConfig ? !fragmentConfig[field] : true

  return (
    <div className="ocs-fragment-btn">
      <button
        className={"ocs-btn ocs-btn-link" + (showFragment ? " active" : "")}
        onClick={onToggleShowFragment}
        disabled={disabled}
      >
        <span className="ocs-btn-no-icon">Fragment</span>
      </button>
      {showFragment && (
        <>
          <section className="d-flex ocs-fragment-fields">
            {showField(FragmentFieldName.startDate) && (
              <div className="ocs-w-184 ocs-mr-4">
                <SeasonDateRange
                  dateRangeStartValue={values.startDate}
                  dateRangeEndValue={values.endDate}
                  showCaption={false}
                  showIcon={false}
                  placeholder={FlightText.dateRange}
                  onChange={(name: string, value: string) => {
                    handleChange(
                      name === "startDate"
                        ? FragmentFieldName.startDate
                        : FragmentFieldName.endDate,
                      value
                    )
                  }}
                />
              </div>
            )}
            {showField(FragmentFieldName.doop) && (
              <div className="ocs-w-72 ocs-mr-12">
                <DOOPField
                  caption={null}
                  value={values.doop}
                  placeholder={FlightText.doop}
                  onChange={(name, value) =>
                    handleChange(FragmentFieldName.doop, value)
                  }
                />
              </div>
            )}
            {showField(FragmentFieldName.separationOption) && (
              <div className="ocs-mr-12 ocs-w-120">
                <DropdownField
                  caption={null}
                  clearable
                  closeOnSelect
                  placeholder={"Split"}
                  value={values.separationOption}
                  options={[
                    { label: byDoop, value: "DOOP" },
                    { label: byDays, value: "DAYS" }
                  ]}
                  onChange={(name, val) =>
                    handleChange(FragmentFieldName.separationOption, val)
                  }
                />
              </div>
            )}
            {showField(FragmentFieldName.splitOption) && (
              <div className="ocs-w-84">
                <DropdownField
                  caption={null}
                  clearable
                  closeOnSelect
                  placeholder={"Arr/Dep"}
                  value={values.splitOption}
                  options={[
                    { label: arr, value: "A" },
                    { label: dep, value: "D" }
                  ]}
                  onChange={(name, val) =>
                    handleChange(FragmentFieldName.splitOption, val)
                  }
                />
              </div>
            )}
          </section>
          <span className="ocs-fragment-btn-combiner" />
        </>
      )}
    </div>
  )
}

